(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6322],{

/***/ 17822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProjectionPage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Mpocket/Accordion.tsx
var Accordion = __webpack_require__(21499);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Library/Projection/index.tsx










var ProjectionPage = function ProjectionPage() {
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/config-utils-main.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Business Plan and Growth Potential",
      subTitleText: "\u4E8B\u696D\u8A08\u753B\u53CA\u3073\u6210\u9577\u53EF\u80FD\u6027"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
      id: "irp-library-category",
      className: "irp-library-category irp-library-category-4"
    })]
  });
};

ProjectionPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: 'IRライブラリー',
    path: '/ir/library/'
  }, {
    name: '事業計画及び成長可能性',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u4E8B\u696D\u8A08\u753B\u53CA\u3073\u6210\u9577\u53EF\u80FD\u6027",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u30B0\u30EB\u30FC\u30D7\u306E\u30D3\u30B8\u30CD\u30B9\u30E2\u30C7\u30EB\u3084\u3001\u4E2D\u9577\u671F\u7684\u306A\u6210\u9577\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306E\u6226\u7565\u3001\u65BD\u7B56\u306A\u3069\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/library/projection/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/ir/library/projection.tsx


/***/ }),

/***/ 68717:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/library/projection",
      function () {
        return __webpack_require__(17822);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,2623,9774,2888,179], function() { return __webpack_exec__(68717); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);